import React from "react"

const Title = ({ text }) => {
  return <h1 className="site-title">{text}</h1>
}

export default Title
